import { Box, Stack } from 'braid-design-system';

import AnimatedHeight from 'src/components/AnimatedHeight/AnimatedHeight';

import { RecsInterceptSurvey } from '../RecsInterceptSurvey/RecsInterceptSurvey';
import { useSignedInDashboardContext } from '../SignedInDashboardContextProvider';
import {
  RECOMMENDATIONS_LIMIT,
  TOP_SECTION_LIMIT,
} from '../hooks/useHomeRecommendations';

import { LoadingRecommendations } from './LoadingRecommendations';
import { RecommendedJobCard } from './RecommendedJobCard';

const LOADING_SKELETON_COUNT = RECOMMENDATIONS_LIMIT - TOP_SECTION_LIMIT;

export const NUMBER_OF_JOBS_BEFORE_SURVEY = 20;

const JOBS_BEFORE_SURVEY_LIMIT =
  NUMBER_OF_JOBS_BEFORE_SURVEY - TOP_SECTION_LIMIT;
export const MoreRecommendationsList = () => {
  const {
    recommendationsResult: { moreJobs },
  } = useSignedInDashboardContext();

  const moreRecommendationsList = moreJobs.map((job, index) => (
    <RecommendedJobCard
      key={`recommendedJob_${job.id}`}
      jobInfo={job}
      position={TOP_SECTION_LIMIT + index + 1}
    />
  ));

  moreRecommendationsList.splice(
    JOBS_BEFORE_SURVEY_LIMIT,
    0,
    <RecsInterceptSurvey key="recsInterceptSurvey" />,
  );

  return moreRecommendationsList;
};

const MoreRecommendationsContent = () => {
  const {
    recommendationsResult: { moreJobs, loading },
  } = useSignedInDashboardContext();

  if (loading) {
    return (
      <LoadingRecommendations
        length={LOADING_SKELETON_COUNT}
        keyPrefix="moreRecs"
      />
    );
  }

  return moreJobs.length ? (
    <Box data={{ automation: 'more-recommendations-content' }}>
      <Stack space="xsmall">
        <MoreRecommendationsList />
      </Stack>
    </Box>
  ) : null;
};

export const MoreRecommendations = () => {
  const {
    recommendationsResult: { loading, moreJobs },
  } = useSignedInDashboardContext();
  return (
    <AnimatedHeight changeKeys={[loading, moreJobs]}>
      <MoreRecommendationsContent />
    </AnimatedHeight>
  );
};
